

import { Component, Vue } from "vue-property-decorator"
import { State } from "vuex-class"

import VuePerfectScrollbar from "vue-perfect-scrollbar"

import RecordNameSetup from "@/components/Config/RecordNameSettings/RecordNameSetup.vue"
import CaseNameSetup from "@/components/Config/CaseNameSettings/CaseNameSetup.vue"
import SeveritySetup from "@/components/Config/Severity/SeveritySetup.vue"
import StatusSetup from "@/components/Config/Status/StatusSetup.vue"
import UserStatusSetup from "@/components/Config/UserStatus/UserStatusSetup.vue"
import TenantSettingsSetup from "@/components/Config/TenantSettings/TenantSettingsSetup.vue"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"
import DomainSetup from "@/components/Config/Domain/DomainSetup.vue"
import CssSetup from "@/components/Config/CssSetup.vue"
import IntegrationSetup from "@/components/Config/Integrations/IntegrationSetup.vue"
import TimeManagement from "./TimeManagement.vue"

@Component({
	components: {
		"help-icon": HelpIcon,
		"scrollbar": VuePerfectScrollbar,
		"tenant-settings-setup": TenantSettingsSetup,
		"status-setup": StatusSetup,
		"severity-setup": SeveritySetup,
		"user-status-setup": UserStatusSetup,
		"case-name-setup": CaseNameSetup,
		"record-name-setup": RecordNameSetup,
		"domain-setup": DomainSetup,
		"css-setup": CssSetup,
		"integration-setup": IntegrationSetup,
		"time-management-setup": TimeManagement
	}
})
export default class TenantSettingsPage extends Vue {
	@State tenantEnabledFeatures!: { [key: string]: boolean }

	get infoEnabled (): boolean {
		return this.tenantEnabledFeatures["tenantInfo"]
	}

	get userUpdatesFeatureEnabled (): boolean {
		return this.tenantEnabledFeatures["userUpdates"]
	}
}

